module.exports = __webpack_public_path__ + "img/continue-button.f2e877fe.svg";